import React from 'react'
import { Route, Switch } from 'react-router'
import Form from './Form'
import List from './List'
import Members from './Members'
import Directory from './Directory'

const Organizations = (props) => {
    return (
        <React.Fragment>
            <Switch>
                <Route path={`${props.match.url}/:code/directory/`} component={() => {
                    return (
                        <React.Fragment>
                            <Route path={`/organizations/:code/directory/new`} component={Members} />
                            <Route path={`/organizations/:code/directory/`} component={Directory} />
                        </React.Fragment>
                    )
                }} />
                <Route path={`${props.match.url}`} component={List} />
            </Switch>
            <Switch>
                <Route path={`${props.match.url}/new`} exact component={Form} />
                <Route path={`${props.match.url}/:code`} exact component={Form} />
                <Route path={`${props.match.url}/:code/members`} exact component={Members} />
            </Switch>
        </React.Fragment>
    )
}


export default Organizations;


// WEBPACK FOOTER //
// ./src/routers/Organizations/index.js